// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"n4-z","displaySixCardTiles":"o4-z"};